import React from "react";
import {
  FaArrowUp,
  FaChartLine,
  FaCheckCircle,
  FaClock,
  FaHeadset,
  FaSearch,
  FaShieldAlt,
  FaWallet,
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";

export const Admindash = () => {
  const stats = [
    {
      title: "Active Campaigns",
      value: "18",
      helper: "+4 this month",
      icon: <FaChartLine />,
      tone: "blue",
    },
    {
      title: "Quota Balance",
      value: "72%",
      helper: "Healthy usage",
      icon: <FaWallet />,
      tone: "green",
    },
    {
      title: "SEO Checks",
      value: "246",
      helper: "32 completed today",
      icon: <FaSearch />,
      tone: "purple",
    },
    {
      title: "Open Tickets",
      value: "05",
      helper: "2 high priority",
      icon: <FaHeadset />,
      tone: "orange",
    },
  ];

  const activities = [
    "Project audit completed for selected URL",
    "Quota refreshed after wallet sync",
    "Support conversation assigned to admin",
  ];

  return (
    <div className="admin-dashboard-page">
      <section className="admin-dashboard-hero">
        <div>
          <span className="admin-dashboard-eyebrow">Seobix Admin</span>
          <h2>Dashboard Overview</h2>
          <p>
            Monitor campaign health, quota usage, and support activity from one
            clean workspace.
          </p>
        </div>
        <div className="admin-dashboard-hero-card">
          <FaShieldAlt />
          <span>Workspace Status</span>
          <strong>Protected</strong>
        </div>
      </section>

      <section className="admin-dashboard-stats">
        {stats.map((stat) => (
          <div className="admin-dashboard-stat-card" key={stat.title}>
            <div className={`admin-dashboard-stat-icon ${stat.tone}`}>
              {stat.icon}
            </div>
            <div>
              <p>{stat.title}</p>
              <h3>{stat.value}</h3>
              <span>
                <FaArrowUp /> {stat.helper}
              </span>
            </div>
          </div>
        ))}
      </section>

      <section className="admin-dashboard-grid">
        <div className="admin-dashboard-panel">
          <div className="admin-dashboard-panel-head">
            <div>
              <span>Performance</span>
              <h4>Project Health</h4>
            </div>
            <FaCheckCircle />
          </div>

          <div className="admin-dashboard-progress-list">
            <div>
              <label>Technical SEO</label>
              <span>86%</span>
              <div className="admin-dashboard-progress">
                <i style={{ width: "86%" }}></i>
              </div>
            </div>
            <div>
              <label>Content Score</label>
              <span>74%</span>
              <div className="admin-dashboard-progress">
                <i style={{ width: "74%" }}></i>
              </div>
            </div>
            <div>
              <label>Backlink Signals</label>
              <span>68%</span>
              <div className="admin-dashboard-progress">
                <i style={{ width: "68%" }}></i>
              </div>
            </div>
          </div>
        </div>

        <div className="admin-dashboard-panel">
          <div className="admin-dashboard-panel-head">
            <div>
              <span>Recent Updates</span>
              <h4>Activity Timeline</h4>
            </div>
            <FaClock />
          </div>

          <div className="admin-dashboard-activity">
            {activities.map((activity, index) => (
              <div key={activity}>
                <span>{index + 1}</span>
                <p>{activity}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Admindash;
